export default __webpack_public_path__ + "static/media/CNo.18-2.3cf1df64.jpg";